// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Bill\ApiBill.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BillCoverage, BillCoverageData, BillCoverageOptions } from 'data/models/BillCoverage';
import { BillExportPayloadAssignment, BillExportPayloadAssignmentData, BillExportPayloadAssignmentOptions } from 'data/models/BillExportPayloadAssignment';
import { BillingSystem, BillingSystemData, BillingSystemOptions } from 'data/models/BillingSystem';
import { BillItem, BillItemData, BillItemOptions } from 'data/models/BillItem';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { QuickBooksJobTracking, QuickBooksJobTrackingData, QuickBooksJobTrackingOptions } from 'data/models/QuickBooksJobTracking';

// BillData is the class that Bill serializes to/from
export interface BillData {
    Id : number;
	
    BillingSystem : BillingSystemData | null;
    BillingSystemId : number;
    Coverage : BillCoverageData[] | null;
    ExportPayloads : BillExportPayloadAssignmentData[] | null;
    Items : BillItemData[] | null;
    To : OrganizationData | null;
    ToId : number | null;
	
    CreationDate : /* ISO8601 */ string;
    Guid : /* GUID */ string;
    InvoiceDate : /* ISO8601 */ string;
    InvoiceNumber : string;
    JobDate : /* ISO8601 */ string;
    QBTracking : QuickBooksJobTrackingData;
    ToAddress : string | null;
}

// BillOptions is the class which may be passed to the Bill constructor to define optional initial data values
export interface BillOptions {
    Id : number;
	
    BillingSystem? : BillingSystemOptions | null;
    BillingSystemId? : number;
    Coverage? : BillCoverageOptions[] | null;
    ExportPayloads? : BillExportPayloadAssignmentOptions[] | null;
    Items? : BillItemOptions[] | null;
    To? : OrganizationOptions | null;
    ToId? : number | null;
	
    CreationDate? : /* ISO8601 */ string;
    Guid? : /* GUID */ string;
    InvoiceDate? : /* ISO8601 */ string;
    InvoiceNumber? : string;
    JobDate? : /* ISO8601 */ string;
    QBTracking? : QuickBooksJobTrackingOptions;
    ToAddress? : string | null;
}

export class Bill {
    public Id : DataSignal<number>;
	
    public BillingSystem : DataSignal<BillingSystem | null>;
    public BillingSystemId : DataSignal<number>;
    public Coverage : SDataArray<BillCoverage>;
    public ExportPayloads : SDataArray<BillExportPayloadAssignment>;
    public Items : SDataArray<BillItem>;
    public To : DataSignal<Organization | null>;
    public ToId : DataSignal<number | null>;
	
    public CreationDate : DataSignal<TZDate>;
    public Guid : DataSignal<string>;
    public InvoiceDate : DataSignal<TZDate>;
    public InvoiceNumber : DataSignal<string>;
    public JobDate : DataSignal<TZDate>;
    public QBTracking : QuickBooksJobTracking;
    public ToAddress : DataSignal<string | null>;

    constructor();
    constructor(data : BillOptions);
    constructor(data: BillOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.BillingSystem = S.value<BillingSystem | null>(null);
        this.BillingSystemId = jsonableObservable(S.value<number>(data && data.BillingSystemId !== undefined ? data.BillingSystemId : 0));
        this.Coverage = SArray<BillCoverage>([]);
        this.ExportPayloads = SArray<BillExportPayloadAssignment>([]);
        this.Items = SArray<BillItem>([]);
        this.To = S.value<Organization | null>(null);
        this.ToId = jsonableObservable(S.value<number | null>(data && data.ToId !== undefined ? data.ToId : null));
	    
        this.CreationDate = jsonableObservable(S.value<TZDate>(data && data.CreationDate !== undefined ? new TZDate(data.CreationDate) : new TZDate(0), TZDate.eq));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.InvoiceDate = jsonableObservable(S.value<TZDate>(data && data.InvoiceDate !== undefined ? new TZDate(data.InvoiceDate) : new TZDate(0), TZDate.eq));
        this.InvoiceNumber = jsonableObservable(S.value<string>(data && data.InvoiceNumber !== undefined ? data.InvoiceNumber : ''));
        this.JobDate = jsonableObservable(S.value<TZDate>(data && data.JobDate !== undefined ? new TZDate(data.JobDate) : new TZDate(0), TZDate.eq));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking();
        this.ToAddress = jsonableObservable(S.value<string | null>(data && data.ToAddress !== undefined ? data.ToAddress : null));
    }

    static key(obj : Bill) {
        return obj.Id();
    }
    
    static dataKey(obj : BillOptions) {
        return obj.Id;
    }

    static update(obj : Bill, data : BillOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.BillingSystemId !== undefined) obj.BillingSystemId(data.BillingSystemId);
            if (data.ToId !== undefined) obj.ToId(data.ToId);
	        
            if (data.CreationDate !== undefined) obj.CreationDate(new TZDate(data.CreationDate));
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.InvoiceDate !== undefined) obj.InvoiceDate(new TZDate(data.InvoiceDate));
            if (data.InvoiceNumber !== undefined) obj.InvoiceNumber(data.InvoiceNumber);
            if (data.JobDate !== undefined) obj.JobDate(new TZDate(data.JobDate));
            if (data.QBTracking !== undefined) QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
            if (data.ToAddress !== undefined) obj.ToAddress(data.ToAddress);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Bill.ts